<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/configuration/domain'">Domain Configuration</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add domain</span>
      } @else {
        <span class="fs-5 fw-bold mb-0">Edit domain</span>
      }
    </li>
  </ol>
</nav>

@if (loaded) {
  <div class="card border-0 shadow mb-3 fade-in-zoom">
    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="row g-3">

          <div class="col-3">
            <label class="form-label">Domain</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-globe"></i></span>
              <input type="text" class="form-control" placeholder="example.com" formControlName="domain">
            </div>
          </div>

          <div class="col-3">
            <label class="form-label">Slug</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-tag"></i></span>
              <select formControlName="slug" class="form-select">
                <option [ngValue]="null">/</option>
                <option value="pl">/pl</option>
              </select>
            </div>
          </div>

          <div class="col-3">
            <label for="product" class="form-label">Brand</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-box"></i></span>
              <select id="product" class="form-select" formControlName="productId">
                <option [ngValue]="null">All products</option>
                @for (product of products; track product) {
                  <option [ngValue]="product.id">{{ product }}</option>
                }
              </select>
            </div>
          </div>

          <div class="col-3">
            <label class="form-label fw-bold small">Language</label>
            <div class="input-group">
              <span class="input-group-text"><i class="bi bi-translate"></i></span>
              <app-dropdown-select formControlName="lang">
                <app-dropdown-select-option [value]="null">All languages</app-dropdown-select-option>
                @for (lang of languages; track lang) {
                  <app-dropdown-select-option [value]="lang.isoCode">
                    <img [ngSrc]="langService.getLanguageFlag(lang)" [alt]="lang.name" class="country-flag"
                         width="24" height="24">
                    {{ lang.name }}
                  </app-dropdown-select-option>
                }
              </app-dropdown-select>
            </div>
          </div>

          <div class="text-end">
            <button type="submit" class="btn btn-primary fw-bold">
              @if (isCreate()) {
                Create
              } @else {
                Update
              }
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
}
